import React from 'react';
import BookingTableRow from './BookingTableRow';
import './BookingsManagement.css';

/**
 * BookingsTable Component - Renders a table of bookings
 * @param {Object} props - Component props
 * @param {Array} props.bookings - Array of booking objects to display
 * @param {Function} props.onStatusChange - Function to handle status changes
 * @param {Function} props.onDelete - Function to handle booking deletion
 * @param {Function} props.onBookingClick - Function to handle booking row click
 * @param {Function} props.onEdit - Function to handle booking edit
 * @returns {JSX.Element} - Rendered component
 */
function BookingsTable({ bookings, onStatusChange, onDelete, onBookingClick, onEdit }) {
  return (
    <div className="bookings-management__table">
      <table>
        <thead>
          <tr>
            <th>Customer</th>
            <th>Vehicle Type</th>
            <th>Service</th>
            <th>Date</th>
            <th>Time</th>
            <th>Status</th>
            <th>Price</th>
            <th>Contact</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {bookings.map(booking => (
            <BookingTableRow
              key={booking.id}
              booking={booking}
              onStatusChange={onStatusChange}
              onDelete={onDelete}
              onClick={() => onBookingClick(booking)}
              onEdit={onEdit}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default BookingsTable; 